import { Dispatch } from 'redux';
import * as ActionTypes from 'src/constants/ActionTypes';
import { ILocationInfo, IAreaInfo } from 'src/entity/LocationEntity';
import LocationService from 'src/services/LocationService';
import { IStoreState, IStateLocation } from 'src/entity/StateEntity';
import { isString } from 'util';

export function reloadLocations(): IStateLocation {
  return {
    reload: true,
    isFetching: false,
    type: ActionTypes.PROVINCE_STATUS_RELOAD,
    locations: [],
  };
}

export function requestLocations(): IStateLocation {
  return {
    reload: false,
    isFetching: true,
    type: ActionTypes.PROVINCE_STATUS_REQUEST,
    locations: [],
  };
}

export function receiveLocations(locations: ILocationInfo[], isSuccess: boolean): IStateLocation {
  return {
    reload: !isSuccess,
    isFetching: false,
    type: isSuccess ? ActionTypes.PROVINCE_STATUS_SUCCESS : ActionTypes.PROVINCE_STATUS_FAILURE,
    locations,
  };
}

function fetchLocations(isDomestic: boolean): any {
  return async (dispatch: Dispatch<IStateLocation>) => {
    dispatch(requestLocations());
    return LocationService.getAllLocation(isDomestic)
      .then((res: ILocationInfo[]) => dispatch(receiveLocations(res, true)))
      .catch((error) => dispatch(receiveLocations([], false)));
  };
}

export function shouldFetchLocations(locationState: IStateLocation): boolean {
  return (locationState.reload || locationState.locations.length === 0) && !locationState.isFetching;
}

export function fetchLocationsIfNeeded(): any {
  return (dispatch: Dispatch<IStateLocation>, getState: any) => {
    const { locationState, userState } = getState() as IStoreState;
    if (shouldFetchLocations(locationState)) {
      return dispatch(fetchLocations(userState.isDomestic));
    }
  };
}

/**
 * 根据locationId获取省市区地区链id数组
 */
export function getLocationChain(locationId: number | undefined): number[] {
  const locationArr: IAreaInfo[] = getLocationInfoChain(locationId);
  return locationArr.map((t) => t.value);
}

/**
 * 根据locationId获取省市区地区链id数组
 */
export function getLocationNameChain(locationId: number | undefined): string[] {
  const locationArr: IAreaInfo[] = getLocationInfoChain(locationId);
  return locationArr.map((t) => t.text);
}

/**
 * 根据locationId获取省市区地区链对象
 */
export function getLocationInfoChain(locationId: number | undefined): IAreaInfo[] {
  const locationArr: IAreaInfo[] = [];
  if (!!locationId) {
    LocationService.getAreaChain(locationId, locationArr);
  }
  return locationArr;
}



// WEBPACK FOOTER //
// ./src/redux/actions/locationCreator.ts